
import './App.css';
import React, { Component } from 'react';
import { t } from './i18n';
import './i18nShell';

function App() {
    const lang = localStorage.getItem('lang') || 'th';
    return (
      <div className="-pre-footer-seo-container js-replace-pre-footer-seo-container">
      <div className="x-index-pre-footer-wrapper">
        <section className="-section-wrapper-1">
          <div className="container">
            <div className="row -row-wrapper">
              <div className="col-12 col-xl-7 -left-container">
                <img
                  src="/build/web/igame-index-lobby-ae-sexy/img/pre-footer-poker-chip-1.png"
                  className="-poker-chip"
                  alt="Ae sexy  Casino Gaming คาสิโนออนไลน์ บาคาร่าออนไลน์"
                />
                <div className="-box-wrapper">
                  <h2 className="-title">Ae sexy</h2>
                  <p className="-description">
                    {t(lang, 'sh_pf_description')}
                  </p>
                </div>
              </div>
              <div className="col-12 col-xl-5 -right-container">
                <img
                  src="/build/web/igame-index-lobby-ae-sexy/img/pre-footer-banner-1-1.png"
                  className="-banner-img"
                  alt="Ae sexy  Casino รูปภาพแบนเนอร์"
                  width={700}
                  height={583}
                />
              </div>
            </div>
          </div>
        </section>
        <section className="-section-wrapper-2">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="-heading-wrapper ">
                  <img
                    src="/build/web/igame-index-lobby-ae-sexy/img/pre-footer-line-glow-red-1.png"
                    className="-red-line"
                    alt="Ae sexy  Casino รูปภาพเส้นสีเรืองแสง"
                    width={480}
                    height={104}
                  />
                  <h2 className="-title">Ae sexy {t(lang, 'sh_pf_casino_for_all')}</h2>
                  <p className="-sub-title">PLATFORM ADVANTAGE</p>
                </div>
                <ul className="navbar-nav">
                  <li className="nav-item -hilo">
                    <img
                      src="/build/web/igame-index-lobby-ae-sexy/img/pre-footer-hilo-1.png"
                      className="-item-icon-img"
                      alt="Ae sexy  Casino รูปภาพเกมส์ ประเภทต่างๆ"
                      width={190}
                      height={190}
                    />
                    <h3 className="-item-title">
                      {t(lang, 'sh_pf_hilo_title')}
                    </h3>
                    <p className="-item-paragraph">
                      {t(lang, 'sh_pf_hilo_paragraph')}
                    </p>
                  </li>
                  <li className="nav-item -rouelete">
                    <img
                      src="/build/web/igame-index-lobby-ae-sexy/img/pre-footer-rouelete-1.png"
                      className="-item-icon-img"
                      alt="Ae sexy  Casino รูปภาพเกมส์ ประเภทต่างๆ"
                      width={190}
                      height={190}
                    />
                    <h3 className="-item-title">
                      {t(lang, 'sh_pf_roulette_title')}
                    </h3>
                    <p className="-item-paragraph">
                      {t(lang, 'sh_pf_roulette_paragraph')}
                    </p>
                  </li>
                  <li className="nav-item -baccarat">
                    <img
                      src="/build/web/igame-index-lobby-ae-sexy/img/pre-footer-baccarat-1.png"
                      className="-item-icon-img"
                      alt="Ae sexy  Casino รูปภาพเกมส์ ประเภทต่างๆ"
                      width={190}
                      height={190}
                    />
                    <h3 className="-item-title">
                      {t(lang, 'sh_pf_baccarat_title')}
                    </h3>
                    <p className="-item-paragraph">
                      {t(lang, 'sh_pf_baccarat_paragraph')}
                    </p>
                  </li>
                  <li className="nav-item -dragontiger">
                    <img
                      src="/build/web/igame-index-lobby-ae-sexy/img/pre-footer-dragontiger-1.png"
                      className="-item-icon-img"
                      alt="Ae sexy  Casino รูปภาพเกมส์ ประเภทต่างๆ"
                      width={190}
                      height={190}
                    />
                    <h3 className="-item-title">
                      {t(lang, 'sh_pf_dragontiger_title')}
                    </h3>
                    <p className="-item-paragraph">
                      {t(lang, 'sh_pf_dragontiger_paragraph')}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="-section-wrapper-3 ">
          <div
            className="-overlay"
            style={{
              backgroundImage:
                "url(/build/web/igame-index-lobby-ae-sexy/img/pre-footer-section-3-bg.png)"
            }}
          />
          <div className="container">
            <div className="row">
              <div className="col-12">
                <img
                  src="/build/web/igame-index-lobby-ae-sexy/img/pre-footer-banner-2-1.png"
                  className="-banner-img img-fluid"
                  alt="Ae sexy  Casino รูปแบนเนอร์เว็บไซต์คาสิโน"
                  width={900}
                  height={450}
                />
              </div>
              <div className="col-12">
                <p className="-description">
                  {t(lang, 'sh_pf_bottom_description')}
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    );
}

export default App;
